<script lang="ts">
  import { page } from "$app/state";
  import ListProducts from "$lib/ListProducts.svelte";
  import MetaData from "$lib/MetaData.svelte";
  import type { Product } from "$lib/types/products";
  import { selectedSort } from "../../sortState.svelte";

  const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

  interface Props {
    data: {
      products: Readonly<Product[]>;
    };
  }

  let { data }: Props = $props();

  let categoryProducts = $state(data?.products);
  let category = $derived(capitalize(page.params.category || ""));
  $effect(() => {
    const sort = selectedSort.sort;
    categoryProducts = data?.products
      ?.map((x) => x)
      ?.sort((a, b) => {
        if (sort?.key === "price") {
          return sort?.order === "asc" ? a.price - b.price : b.price - a.price;
        } else if (sort?.key === "title") {
          // For title sorting
          const comparison = a.title.localeCompare(b.title);
          return sort?.order === "asc" ? comparison : -comparison;
        }
        return 0;
      });
  });
</script>

<MetaData
  data={{
    title: `${category || "Smarte produkter"} i nettbutikken`,
    description: `${category || "Smarte produkter"} i Ishavskrafts nettbutikk. Finn smarte løsninger som gjør strøm enklere.`,
  }}
/>

{#if categoryProducts}
  <ListProducts products={categoryProducts} />
{/if}
